export const SELECT_TOOTH = "SELECT_TOOTH";
export const NEW_TOOTH_SELECTION = "NEW_TOOTH_SELECTION";
